import React from 'react'

export type ColumnDef<T> = {
  header: React.ReactNode
  width?: string
  renderCell: (row: T, index: number) => React.ReactNode
}

type DynamicTableProps<T> = {
  columns: ColumnDef<T>[]
  data: T[]
  extraClassName?: string
  emptyMessage?: string
}


const DynamicTable = <T,>({
  columns,
  data,
  extraClassName = 'align-middle w-800px mx-auto',
  emptyMessage = 'No records found.',
}: DynamicTableProps<T>) => {
  return (
    <table className={`table table-bordered border-secondary ${extraClassName}`}>
      <thead>
        <tr className="bg-secondary align-middle text-gray-700">
          {columns.map((col, idx) => (
            <th key={idx} style={{ width: col.width }}>{col.header}</th>
          ))}
        </tr>
      </thead>
      <tbody className='align-middle'>
        {data.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className='text-center text-muted p-4'>
              {emptyMessage}
            </td>
          </tr>
        ) : (
          data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>{col.renderCell(row, rowIndex)}</td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  )
}

export default DynamicTable
